<template>
    <el-container>
        <el-aside class="aside-classify-tree">
            <el-header class="extdnd-group-aside-header-class">
                <span style="font-weight:bold">{{ $t('pgCommon.MODEL_MANAGEMENT') }}</span>
            </el-header>
            <el-main style="height:auto">
                <!-- 加载流程组单列表-->
                <td-single-list
                    ref="tdSingleList"
                    rowKey="deploymentId"
                    :height="listHeight"
                    :hasDefaultSelection="true"
                    :hasPageMemory="true"
                    :lazyloading="true"
                    :hasAddElement="true"
                    :columnObj="columnObj"
                    @currentChange="selectionChange"
                    :operateColumn="operateColumn"
                    :hasOperational="true"
                    @addElement="add"
                    :interfaceName="interfaceName"
                ></td-single-list>
            </el-main>
        </el-aside>
        <el-container style="width:100%">
            <el-main style="height: 100%;">
                <el-form :inline="true" :model="fromWorkFlow" ref="fromWorkFlow" class="demo-form-inline">
                    <el-form-item :label="$t('pgCommon.PRODEFKEY')" prop="templateKey">
                        <td-input v-model="fromWorkFlow.templateKey" :disabled="true"></td-input>
                    </el-form-item>
                    <el-form-item :label="$t('pgCommon.WORK_FLOW_CAPTION')" prop="templateName">
                        <td-input v-model="fromWorkFlow.templateName" :disabled="true"></td-input>
                    </el-form-item>
                    <el-form-item class="paddingLeft10">
                        <td-button type="primary" @click="designDataSource">{{ $t('pgCommon.DESIGN_DATA_SOURCE') }} </td-button>
                    </el-form-item>
                    <el-form-item>
                        <td-button @click="exportFormModel">{{ $t('pgCommon.EXPORT_FORM') }} </td-button>
                    </el-form-item>
                    <el-form-item>
                        <td-button @click="exportFormDel">{{ $t('pgCommon.EXPORT_DEL') }} </td-button>
                    </el-form-item>
                </el-form>
                <!-- 加载表格 -->
                <el-row>
                    <el-col>
                        <td-table :columns="nodecolumns" :hasPage="false" :hasMutiSelect="false" :dataSource="nodetableData" :hasLoading="nodeloading" ref="nodetable"> </td-table>
                    </el-col>
                </el-row>
                <!-- 加载扩展组dialog -->
                <dialog-design
                    v-if="dialogDesignVisible"
                    :dialogDesignVisible="dialogDesignVisible"
                    :templateKey="templateKey"
                    :templateId="templateId"
                    :designParam="designParam"
                    :title="title"
                    @designDialogClose="designDialogClose"
                ></dialog-design>
                <!-- 加载dialog -->
                <dialog-user
                    v-if="dialogUserVisible"
                    :dialogUserVisible="dialogUserVisible"
                    :listProInfo="listProInfo"
                    :listCsmInfo="listCsmInfo"
                    :title="userTitle"
                    :isAdd="isAdd"
                    :templateKey="templateKey"
                    :userParam="userParam"
                    @userDialogClose="userDialogClose"
                    @submit="submit"
                ></dialog-user>
                <!-- 加载dialog -->
                <dialog-role
                    v-if="dialogRoleVisible"
                    :dialogRoleVisible="dialogRoleVisible"
                    :listProInfo="listProInfo"
                    :listCsmInfo="listCsmInfo"
                    :title="roleTitle"
                    :isAdd="isAdd"
                    :roleParam="roleParam"
                    :templateKey="templateKey"
                    @roleDialogClose="roleDialogClose"
                    @submit="submit"
                ></dialog-role>
                <!-- 设置角色 -->
                <dialogSetRole v-if="setRoleVisible" :setRoleInfo="setRoleInfo" :templateKey="templateKey" :setRoleVisible="setRoleVisible" @setRoleDialogClose="setRoleDialogClose"></dialogSetRole>
                <dialog-url
                    v-if="dialogClassVisible"
                    :dialogClassVisible="dialogClassVisible"
                    :title="classTitle"
                    :templateKey="templateKey"
                    :classParam="classParam"
                    @classDialogClose="classDialogClose"
                ></dialog-url>
            </el-main>
        </el-container>
        <el-container>
            <designDataSourceDialog
                v-if="designDataSourceDialogVisible"
                :designDataSourceDialogVisible="designDataSourceDialogVisible"
                :templateKey="fromWorkFlow.templateKey"
                @designDataSourceDialogColse="designDataSourceDialogColse"
            ></designDataSourceDialog>
        </el-container>
        <el-container>
            <copyTemplateDialog
                v-if="copyTemplateDialogVisible"
                :copyTemplateDialogVisible="copyTemplateDialogVisible"
                @copyTemplateDialogColse="copyTemplateDialogColse"
                :nodetableData="this.nodetableData"
                :templateKey="fromWorkFlow.templateKey"
                :btnCopyTemplateInfo="this.btnCopyTemplateInfo"
            ></copyTemplateDialog>
        </el-container>
        <el-container>
            <procParamsSetDialog
                v-if="procParamsSetDialogVisible"
                :procParamsSetDialogVisible="procParamsSetDialogVisible"
                @procParamsSetDialogColse="procParamsSetDialogColse"
                :title="procParamsTitle"
                :item="rowData"
                :templateKey="fromWorkFlow.templateKey"
            ></procParamsSetDialog>
        </el-container>
        <el-container>
            <dialogNextUser
                v-if="dialogNextUserVisible"
                :dialogNextUserVisible="dialogNextUserVisible"
                @dialogNextUserDialogColse="dialogNextUserDialogColse"
                :title="userTitle"
                :item="userParam"
                :templateKey="templateKey"
            ></dialogNextUser>
        </el-container>
    </el-container>
</template>
<script>
import extendGroupApi from './assets/api.js';
import Api from './assets/api.js';
import userDialog from './components/userDialog.vue';
import roleDialog from './components/roleDialog.vue';
import dialogSetRole from './components/dialogRole.vue';
import designDialog from './components/designForm.vue';
import designDataSourceDialog from './components/designDataSourceDialog.vue';
import copyTemplateDialog from './components/copyTemplateDialog.vue';
import procParamsSetDialog from './components/processParamsDialog.vue';
import dialogNextUser from './components/nextUserDialog.vue';
import urlDialog from './components/urlSettingDialog.vue';
export default {
    // 初始化渲染
    components: {
        dialogSetRole,
        copyTemplateDialog,
        designDataSourceDialog,
        'dialog-user': userDialog,
        'dialog-role': roleDialog,
        'dialog-design': designDialog,
        'dialog-url': urlDialog,
        procParamsSetDialog,
        dialogNextUser
    },
    created() {},
    mounted() {
        // this.$refs.tdSingleList.getTableData(); // 进行页面初始化数据的加载
    },
    data() {
        return {
            rowData: null,
            procParamsTitle: '',
            btnCopyTemplateInfo: {},
            dialogClassVisible: false,
            procParamsSetDialogVisible: false,
            copyTemplateDialogVisible: false,
            designDataSourceDialogVisible: false,
            setRoleVisible: false,
            permissionsAdd: ['workflow:add'],
            permissionsEdit: ['workflow:edit'],
            permissionsView: ['workflow:view'],
            permissionsDel: ['workflow:del'],
            permissionsImport: ['workflow:import'],
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            listHeight: window.innerHeight - 245,
            dialogUserVisible: false,
            dialogRoleVisible: false,
            dialogDesignVisible: false,
            dialogNextUserVisible: false,
            fromWorkFlow: { templateName: '', templateKey: '', templateId: ''},
            interfaceName: { query: '/templateManage/queryTemplate', search: '/templateManage/queryTemplate' },
            templateParam: {},
            nodetableData: [],
            tableData: [],
            setRoleInfo: '',
            //单列表对象
            columnObj: {
                id: 'templateKey',
                prop: 'templateName'
            },
            //单列表操作项
            operateColumn: {
                width: '95',
                align: 'center',
                render: (createElement, params) => {
                    return createElement('div', [
                        createElement('td-button', {
                            style: {
                                'background-image': 'url(' + window.config.treeIcon + window.vue.$store.state.skin + '/img/tree/edit.png' + ') ',
                                'background-repeat': 'no-repeat',
                                'background-color': 'transparent',
                                border: '0px',
                                'background-position': 'right',
                                'padding-top': '15px'
                            },
                            props: { permissions: this.permissionsEdit, size: 'mini' },
                            on: {
                                click: () => {
                                    this.edit(params.row.modelId);
                                }
                            }
                        }),
                        createElement('td-button', {
                            style: {
                                'background-image': 'url(' + window.config.treeIcon + window.vue.$store.state.skin + '/img/tree/delete.png' + ') ',
                                'background-repeat': 'no-repeat',
                                'background-color': 'transparent',
                                border: '0px',
                                'background-position': 'center',
                                'padding-top': '15px'
                            },
                            props: { permissions: this.permissionsDel, size: 'mini' },
                            on: {
                                click: () => {
                                    this.delete(params.row.templateKey);
                                }
                            }
                        })
                    ]);
                }
            },
            nodecolumns: [
                //表头
                {
                    prop: 'taskKey',
                    label: 'pgCommon.NODE_KEY',
                    align: 'left',
                    render: (createElement, params) => {
                        if (!params.row.taskKey) {
                            return createElement('div', this.$t('pgCommon.RESERVATION_NODATA'));
                        } else {
                            return createElement('div', params.row.taskKey);
                        }
                    }
                },
                {
                    prop: 'taskName',
                    label: 'pgCommon.NODE_CAPTION',
                    align: 'left',
                    render: (createElement, params) => {
                        if (!params.row.taskName) {
                            return createElement('div', this.$t('pgCommon.RESERVATION_NODATA'));
                        } else {
                            return createElement('div', params.row.taskName);
                        }
                    }
                },
                {
                    label: 'pgCommon.PERMISSIONS',
                    align: 'center',
                    render: (createElement, params) => {
                        let list = [];
                        if (params.row.taskType == 'UserTask') {
                            list = [
                                createElement(
                                    'td-button',
                                    {
                                        props: { type: 'text', size: 'small' },
                                        on: {
                                            click: () => {
                                                this.btnSetUserNode(params.row);
                                            }
                                        }
                                    },
                                    this.$t('pgCommon.SET_USER')
                                ),
                                createElement(
                                    'td-button',
                                    {
                                        props: { type: 'text', size: 'small' },
                                        on: {
                                            click: () => {
                                                this.btnSetRole(params.row);
                                            }
                                        }
                                    },
                                    this.$t('pgCommon.SET_USER_ROLE')
                                ),
                                createElement(
                                    'td-button',
                                    {
                                        props: { type: 'text', size: 'small' },
                                        on: {
                                            click: () => {
                                                this.btnSetRoleNode(params.row);
                                            }
                                        }
                                    },
                                    this.$t('pgCommon.SET_ROLE')
                                ),
                                createElement(
                                    'td-button',
                                    {
                                        props: { type: 'text', size: 'small' },
                                        on: {
                                            click: () => {
                                                this.setNextUser(params.row);
                                            }
                                        }
                                    },
                                    this.$t('pgCommon.SET_NEXT_TASK')
                                )
                            ];
                        }
                        return createElement('div', list);
                    }
                },
                {
                    label: 'pgCommon.OPERATE',
                    align: 'center',
                    render: (createElement, params) => {
                        let list = [];
                        if (params.row.taskType == 'UserTask') {
                            list = [
                                createElement(
                                    'td-button',
                                    {
                                        props: { type: 'text', size: 'small' },
                                        on: {
                                            click: () => {
                                                this.btnDesignForm(params.row);
                                            }
                                        }
                                    },
                                    this.$t('pgCommon.DESIGN_FORM')
                                ),
                                createElement(
                                    'td-button',
                                    {
                                        props: { type: 'text', size: 'small' },
                                        on: {
                                            click: () => {
                                                this.btnCopyTemplate(params.row);
                                            }
                                        }
                                    },
                                    this.$t('pgCommon.COPY_TEMPLATE')
                                ),
                                createElement(
                                    'td-button',
                                    {
                                        props: { type: 'text', size: 'small' },
                                        on: {
                                            click: () => {
                                                this.btnFlowParams(params.row);
                                            }
                                        }
                                    },
                                    this.$t('pgCommon.SET_PARAMS')
                                ),
                                createElement(
                                    'td-button',
                                    {
                                        props: { type: 'text', size: 'small' },
                                        on: {
                                            click: () => {
                                                this.executeClass(params.row);
                                            }
                                        }
                                    },
                                    this.$t('pgCommon.TASK_LISTENER')
                                )
                            ];
                        } else if (params.row.taskType == 'ServiceTask') {
                            list = [
                                createElement(
                                    'td-button',
                                    {
                                        props: { type: 'text', size: 'small' },
                                        on: {
                                            click: () => {
                                                this.executeClass(params.row);
                                            }
                                        }
                                    },
                                    this.$t('pgCommon.SERVICE_DELEGATE')
                                )
                            ];
                        } else if (params.row.taskType == 'EndEvent') {
                            list = [
                                createElement(
                                    'td-button',
                                    {
                                        props: { type: 'text', size: 'small' },
                                        on: {
                                            click: () => {
                                                this.btnDesignForm(params.row);
                                            }
                                        }
                                    },
                                    this.$t('pgCommon.DESIGN_FORM')
                                ),
                                createElement(
                                    'td-button',
                                    {
                                        props: { type: 'text', size: 'small' },
                                        on: {
                                            click: () => {
                                                this.btnCopyTemplate(params.row);
                                            }
                                        }
                                    },
                                    this.$t('pgCommon.COPY_TEMPLATE')
                                )
                            ];
                        }
                        return createElement('div', list);
                    }
                }
            ] //节点列表字段
        };
    },
    methods: {
        classDialogClose() {
            this.dialogClassVisible = false;
        },
        copyTemplateDialogColse() {
            this.copyTemplateDialogVisible = false;
        },
        btnCopyTemplate(e) {
            this.btnCopyTemplateInfo = e;
            this.copyTemplateDialogVisible = true;
        },
        designDataSourceDialogColse() {
            this.designDataSourceDialogVisible = false;
        },
        designDataSource() {
            if (!this.fromWorkFlow.templateKey) {
                this.$message({ type: 'error', showClose: true, message: this.$t('pgCommon.SET_UP_THE_PROCESS_FIRST') });
                return;
            }
            this.designDataSourceDialogVisible = true;
        },
        exportFormModel() {
            let para = {
                proDefKey: this.fromWorkFlow.templateKey
            };
            Api.exportFormModel(JSON.stringify(para), response => {
                if (response.data.statusCode == 'NOT_EXISTS_FORM_SQL') {
                    this.$message({ type: 'warning', showClose: true, message: response.data.statusMessage });
                } else {
                    let blob = new Blob(['\ufeff' + response.data], { type: 'text/html;charset=UTF-8' });
                    this.content = response.data;
                    this.epLoading = false;
                    // 汉字解码
                    let filename = decodeURIComponent(response.headers['filename']);
                    if (window.navigator.msSaveOrOpenBlob) {
                        // 兼容IE10
                        navigator.msSaveBlob(blob, filename);
                    } else {
                        //  chrome/firefox
                        let aTag = document.createElement('a');
                        aTag.download = filename;
                        aTag.href = window.URL.createObjectURL(blob);
                        aTag.click();
                        URL.revokeObjectURL(aTag.href);
                    }
                }
            });
        },
        exportFormDel() {
            let para = {
                templateKey: this.fromWorkFlow.templateKey,
                templateId: this.fromWorkFlow.templateId
            };
            Api.exportFormDel(JSON.stringify(para), response => {
                if (response.data.statusCode == 'NOT_EXISTS_FORM_SQL') {
                    this.$message({ type: 'warning', showClose: true, message: response.data.statusMessage });
                } else {
                    let blob = new Blob(['\ufeff' + response.data], { type: 'text/html;charset=UTF-8' });
                    this.content = response.data;
                    this.epLoading = false;
                    // 汉字解码
                    let filename = decodeURIComponent(response.headers['filename']);
                    if (window.navigator.msSaveOrOpenBlob) {
                        // 兼容IE10
                        navigator.msSaveBlob(blob, filename);
                    } else {
                        //  chrome/firefox
                        let aTag = document.createElement('a');
                        aTag.download = filename;
                        aTag.href = window.URL.createObjectURL(blob);
                        aTag.click();
                        URL.revokeObjectURL(aTag.href);
                    }
                }
            });
        },
        //选择事件
        selectionChange(currentRow) {
            if (currentRow == null) {
                return;
            }
            this.fromWorkFlow.templateKey = currentRow.templateKey;
            this.fromWorkFlow.templateName = currentRow.templateName;
            this.fromWorkFlow.templateId = currentRow.templateId;
            this.templateParam = currentRow;
            this.callbackQuery();
        },
        // 刷新单列表事件
        btnQuery() {
            window.vue.$apiAxios.postRequestBody(
                '/templateManage/queryTemplate',
                '{pageSize: 30, currentPage: 1, needPage: true, flag: true}',
                response => {
                    if (response.status === this.$common.login.RESPONSE_STATUS && response.data && response.data.statusCode === this.$common.requestCode.SUCCESS_INFO_CODE) {
                        if (this.$util.isEmpty(response.data.content)) {
                            this.$log.error('tdSingleList/queryData/response.data.content-------is error', response.data);
                        } else {
                            let tableNewData = response.data.content;
                            this.$refs.tdSingleList.tableData = [];
                            this.$refs.tdSingleList.tableData = tableNewData;
                        }
                    } else {
                        this.$log.error('tdSingleList/queryData---------staus is error', response.status);
                    }
                },
                null,
                null,
                this.token
            );
        },
        //添加
        add() {
            let _this = this;
            Api.newModel('', response => {
                if (response.data.ret !== this.$common.requestCode.SUCCESS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.$log.error('templateManage/immediatelyEnable', response.data.message);
                    return;
                }
                if (response.data == null) {
                    this.loading = false;
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.$log.error('templateManage/queryTemplate', response.data.message);
                    return;
                }
                //如果成功，则读取后端返回的操作指令
                let result = response.data;
                if (result['msg']) {
                    alert(result.msg);
                }
                //刷新
                if (result['refresh']) {
                    window.location.reload();
                    return;
                }
                //返回
                if (result['back']) {
                    window.location.href = document.referrer;
                }
                //跳转
                if (result['redirectUrl'] != null) {
                    let winObj = window.open(
                        window.config.host + '/' + result.redirectUrl,
                        '',
                        'width=' + (window.screen.availWidth - 10) + ',height=' + (window.screen.availHeight - 60) + ',top=0,left=0,Toolbar=no,location=no,resizable=yes'
                    );
                    let loop = setInterval(function() {
                        if (winObj && winObj.closed) {
                            clearInterval(loop);
                            _this.btnQuery();
                        }
                    }, 1000);
                    return;
                }
                return result.data;
            });
        },
        // 删除
        delete(templateKey) {
            this.$confirm(this.$t('pgCommon.DELETE_TEMPLATE_INFO_TIPS'), this.$t('pgCommon.TIPS'), {
                cancelButtonText: this.$t('pgCommon.CANCEL'),
                confirmButtonText: this.$t('pgCommon.SURE'),
                type: 'warning'
            })
                .then(() => {
                    let param = { proDefKey: templateKey };
                    let _this = this;
                    this.$confirm(this.$t('pgCommon.DELETE_TEMPLATE_TABLE_INFO_TIPS'), this.$t('pgCommon.TIPS'), {
                        cancelButtonText: this.$t('pgCommon.NOT'),
                        confirmButtonText: this.$t('pgCommon.YES'),
                        type: 'warning'
                    })
                        .then(() => {
                            param = {
                                proDefKey: templateKey,
                                systemId: 'DELETE_TABLE'
                            };
                            Api.deleteTemplate(JSON.stringify(param), response => {
                                _this.templateId = [];
                                if (response.status !== _this.$common.login.RESPONSE_STATUS) {
                                    _this.$message({ type: 'error', showClose: true, message: _this.$t('error.ERROR_RESPONSE') });
                                    _this.loading = false;
                                    _this.$log.error('templateManage/queryTemplate', response);
                                    return;
                                }
                                if (response.data.statusCode !== _this.$common.requestCode.SUCCESS_INFO_CODE) {
                                    _this.loading = false;
                                    _this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                                    _this.$log.error('templateManage/queryTemplate', response.data.message);
                                    return;
                                }
                                _this.multipleSelection = null;
                                // let param = 'PROCESS_' + _this.fromWorkFlow.templateKey;
                                // Api.selfBuildTableDrop(param, response => {
                                //     if (response.status !== _this.$common.login.RESPONSE_STATUS) {
                                //         _this.$message({ type: 'error', showClose: true, message: _this.$t('error.ERROR_RESPONSE') });
                                //         _this.loading = false;
                                //         _this.$log.error('templateManage/queryTemplate', response);
                                //         return;
                                //     }
                                //     if (response.data.statusCode !== _this.$common.requestCode.SUCCESS_INFO_CODE) {
                                //         _this.loading = false;
                                //         _this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                                //         _this.$log.error('templateManage/queryTemplate', response.data.message);
                                //         return;
                                //     }
                                //     });
                                _this.$message({ type: 'success', showClose: true, message: _this.$t('pgCommon.DELETE_SUCCESS') });
                                _this.btnQuery();
                                _this.fromWorkFlow.templateKey = '';
                                _this.fromWorkFlow.templateName = '';
                            });
                        })
                        .catch(() => {
                            Api.deleteTemplate(JSON.stringify(param), response => {
                                _this.templateId = [];
                                if (response.status !== _this.$common.login.RESPONSE_STATUS) {
                                    _this.$message({ type: 'error', showClose: true, message: _this.$t('error.ERROR_RESPONSE') });
                                    _this.loading = false;
                                    _this.$log.error('templateManage/queryTemplate', response);
                                    return;
                                }
                                if (response.data.statusCode !== _this.$common.requestCode.SUCCESS_INFO_CODE) {
                                    _this.loading = false;
                                    _this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                                    _this.$log.error('templateManage/queryTemplate', response.data.message);
                                    return;
                                }
                                _this.multipleSelection = null;
                                // let param = 'PROCESS_' + _this.fromWorkFlow.templateKey;
                                // Api.selfBuildTableDrop(param, response => {
                                //     if (response.status !== _this.$common.login.RESPONSE_STATUS) {
                                //         _this.$message({ type: 'error', showClose: true, message: _this.$t('error.ERROR_RESPONSE') });
                                //         _this.loading = false;
                                //         _this.$log.error('templateManage/queryTemplate', response);
                                //         return;
                                //     }
                                //     if (response.data.statusCode !== _this.$common.requestCode.SUCCESS_INFO_CODE) {
                                //         _this.loading = false;
                                //         _this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                                //         _this.$log.error('templateManage/queryTemplate', response.data.message);
                                //         return;
                                //     }
                                //     });
                                _this.$message({ type: 'success', showClose: true, message: _this.$t('pgCommon.DELETE_SUCCESS') });
                                _this.btnQuery();
                                _this.fromWorkFlow.templateKey = '';
                                _this.fromWorkFlow.templateName = '';
                            });
                        });
                })
                .catch(() => {
                    this.$log.error('templateManage/delete---- Fail');
                });
        },
        //编辑
        edit(templateId) {
            let _this = this;
            let winObj = window.open(
                window.config.host + '/' + 'modeler.html?modelId=' + templateId,
                '',
                'width=' + (window.screen.availWidth - 10) + ',height=' + (window.screen.availHeight - 60) + ',top=0,left=0,Toolbar=no,location=no,resizable=yes'
            );
            let loop = setInterval(function() {
                if (winObj.closed) {
                    clearInterval(loop);
                    _this.btnQuery();
                }
            }, 1000);
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.listQuery();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.listQuery();
        },
        // 回调查询
        callbackQuery() {
            this.listQuery();
        },
        // 查询数据
        listQuery() {
            let param = {
                templateId: this.templateParam.templateId,
                templateKey: this.templateParam.templateKey
            };
            this.nodeloading = true;
            Api.getNodeInfo(param, response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.loading = false;
                    this.nodeloading = false;
                    this.$log.error('queryTemplate', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.loading = false;
                    this.nodeloading = false;
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.$log.error('queryTemplate', response.data.statusMessage);
                    return;
                }
                this.nodetableData = response.data.content;
                this.nodeloading = false;
            });
        },
        setNextUser: function(item) {
            this.userTitle = this.$t('pgCommon.ASSIGN_FOLLOWING_AUDIT_AUTHORITY'); // 标题
            this.userParam = item;
            this.templateKey = this.templateParam.templateKey;
            this.dialogNextUserVisible = true;
        },
        dialogNextUserDialogColse: function() {
            this.dialogNextUserVisible = false;
        },
        btnSetUserNode: function(item) {
            this.userTitle = this.$t('pgCommon.SET_USER'); // 标题
            this.userParam = item;
            this.templateKey = this.templateParam.templateKey;
            this.dialogUserVisible = true;
        },
        userDialogClose: function() {
            this.dialogUserVisible = false;
        },
        btnSetRoleNode: function(item) {
            this.roleTitle = this.$t('pgCommon.SET_ROLE'); // 标题
            this.roleParam = item;
            this.templateKey = this.templateParam.templateKey;
            this.dialogRoleVisible = true;
        },
        //分配角色
        btnSetRole(item) {
            this.setRoleVisible = true;
            this.setRoleInfo = item;
            this.templateKey = this.templateParam.templateKey;
        },
        roleDialogClose: function() {
            this.dialogRoleVisible = false;
        },
        btnDesignForm: function(item) {
            this.title = this.$t('pgCommon.DESIGN_TASK_FORM');
            this.designParam = item;
            this.templateKey = this.templateParam.templateKey;
            this.templateId = this.templateParam.templateId;
            this.dialogDesignVisible = true;
        },
        // 设置流程条件事件
        btnFlowParams: function(item) {
            this.procParamsSetDialogVisible = true;
            this.procParamsTitle = this.$t('pgCommon.SET_PARAMS');
            this.rowData = item;
        },
        // 服务接口配置
        executeClass: function(item) {
            if (item.taskType == 'ServiceTask') {
                this.classTitle = this.$t('pgCommon.SERVICE_DELEGATE'); // 标题
            } else if (item.taskType == 'UserTask') {
                this.classTitle = this.$t('pgCommon.TASK_LISTENER'); // 标题
            }
            this.classParam = item;
            this.templateKey = this.templateParam.templateKey;
            this.dialogClassVisible = true;
        },
        designDialogClose: function() {
            this.dialogDesignVisible = false;
        },
        procParamsSetDialogColse: function() {
            this.procParamsSetDialogVisible = false;
        },
        // 编辑节点回显到单列表
        updateTableNode(tableData) {
            this.$refs.tdSingleList.updateTableData('modify', tableData);
        },
        // 添加节点回显到单列表
        addTableNode(tableData) {
            this.$refs.tdSingleList.updateTableData('add', tableData);
        },
        //获取排序后的表格数据，并更新数据库
        getSortData(oldIndex, newIndex, formatData) {
            for (let i = 0; i < formatData.length; i++) {
                formatData[i].iOrder = i + 1;
            }
            extendGroupApi.updateSortInfo(JSON.stringify(formatData), response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    this.$log.error('extendManage/updateSortInfo', response);
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('extendManage/updateSortInfo', response.data.statusMessage);
                    return;
                }
            });
        },
        //角色分配页面关闭
        setRoleDialogClose() {
            this.setRoleVisible = false;
        }
    }
};
</script>
<style></style>
